import { useId, useState } from 'react';
export default function CheckboxList({ items, name, selected=[], label, onChange }) {

    const buttonListId = useId();

    const listItems = items.map(item =>
        <div key={item.name} className="checked-item">
            <input id={buttonListId + item.value} type="checkbox" name={name} value={item.value} className="checked-item__input" data-label={item.name} defaultChecked={selected?.includes(item.value)} onChange={onChange} />
            <label htmlFor={buttonListId + item.value} className="checked-item__label">
                {item.name}
            </label>
        </div>
    );

    return (
        <fieldset>
            <legend className="legend">{label}</legend>
            {listItems}
        </fieldset>
    );
}